import React from "react";

type SplitSectionRoutineProps = {
    heading: string;
    paragraphs: string[];
    imageSrc: string;
    backgroundColor?: string;
    imageAlt?: string;
    reversed?: boolean;
};

const SplitSectionRoutine: React.FC<SplitSectionRoutineProps> = ({
    heading,
    paragraphs,
    imageSrc,
    backgroundColor = "#FFFFFF",
    imageAlt = "Illustration",
    reversed = false
}) => {
    return (
        <section className="w-full bg-white py-16 md:py-24" style={{ backgroundColor: backgroundColor }}>
            <div className={`container mx-auto flex flex-col ${reversed ? 'md:flex-row-reverse' : 'md:flex-row'} items-center px-6 md:px-12 lg:px-20`}>
                
                {/* Image */}
                <div className="md:w-1/2 w-full mb-12 md:mb-0">
                    <img 
                        src={imageSrc} 
                        alt={imageAlt}
                        className="rounded-lg shadow-lg w-full object-cover"
                    />
                </div>

                {/* Text */}
                <div className="md:w-1/2 w-full flex items-center justify-center">
                    <div className="text-center">
                        <h2 className="text-4xl font-bold text-blue-900 mb-6">
                            {heading}
                        </h2>
                        {paragraphs.map((text, i) => (
                            <p
                                key={i}
                                className="text-lg text-blue-900 mb-4 max-w-md mx-auto"
                            >
                                {text}
                            </p>
                        ))}
                    </div>
                </div>
            </div>
        </section>
    );
};

export default SplitSectionRoutine;
